import BoxTitle from "@/routes/org/_components/box-title"
import { langStore } from "@/stores/lang-store"
import StackBarChart from "@/routes/org/_components/leak-severity/stack-bar-chart"
import Wrapper from "@/components/wrapper"
import { leakSeverityBundle } from "./leak-severity-const"

const LeakSeverityView = ({ series, yLabels }) => {
  const lang = langStore((s) => s.lang)

  return (
    <Wrapper.shadow className={"flex-1"}>
      <BoxTitle title={leakSeverityBundle.title[lang]} />
      <StackBarChart series={series} yLabels={yLabels} />
    </Wrapper.shadow>
  )
}

export default LeakSeverityView
